import axios from 'axios';
import { all, fork, takeLatest, call, put } from 'redux-saga/effects';
import { API_BASE_URL } from "../constants/config";
import actionTypes from "../constants/actionTypes";

function* menu() {
    try {
        const token = localStorage.getItem('token');
        const config = {
            headers: {
                'Authorization': `${token}`
            }
        };
        const data = yield call(axios.get, API_BASE_URL + "/menu?projectId=1",config);
        yield put({
            type: actionTypes.MENU_ON_RESULT,
            menuData: data
        });
    } catch (e) {
        // Handle error if needed
    }
}

function* menuClick(action) {
    // Use the action's payload as data
    const clickSubMenuItem = action.payload?.clickSubMenuItem;
    const data = action.payload?.data;
    yield put({
        type: actionTypes.MENU_CLICK_RESULT,
        clickSubMenuItems: data,
        clickSubMenuItem: clickSubMenuItem
    });
}

function* watchMenu() {
    yield takeLatest(actionTypes.MENU_ON, menu);
}

function* watchMenuClick() {
    yield takeLatest(actionTypes.MENU_CLICK, menuClick); // Pass action to menuClick
}

export default function* menuSaga() {
    yield all([
        fork(watchMenu),
        fork(watchMenuClick)
    ]);
}
